<template>
  <div id="more" class="ArticleMore">
    <div class="ArticleMore__header">
      <h2 class="ArticleMore__title">More For You</h2>
      <a class="ArticleMore__link" href="/blogs/journal">Read all stories</a>
    </div>
    <div class="ArticleMore__tiles">
      <JournalTile
        v-for="entry in journalEntries"
        :key="entry.id"
        :entry="entry"
      />
    </div>
  </div>
</template>

<script>
import journalQuery from "@/graphql/queries/JournalTiles.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { RelayConnection } from "@/helpers/pagination";
import JournalTile from "@/components/journal/JournalTile";

export default {
  name: "ArticleMore",
  components: {
    JournalTile,
  },
  props: {
    handle: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      journal: {
        articles: new RelayConnection(),
      },
    };
  },
  computed: {
    journalEntries() {
      const nodes = unwrapNodes(this.journal.articles?.edges);
      if (this.handle) {
        return nodes.filter((node) => node?.handle !== this.handle);
      } else {
        return nodes;
      }
    },
  },
  apollo: {
    journal: {
      query: journalQuery,
      update: (data) => data.blog,
    },
  },
};
</script>

<style lang="scss" scoped>
.ArticleMore {
  background: $color-grey-light;
  padding: 40px 0;

  @include respond-above(md) {
    padding: 80px 0 60px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 10px;
    margin-bottom: 10px;

    @include respond-above(md) {
      padding: 0 20px;
    }
  }

  &__title {
    font-size: 16px;
    font-weight: normal;
    text-transform: uppercase;

    @include respond-above(md) {
      font-size: 30px;
    }
  }

  &__link {
    color: $color-grey-dark;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.55px;
    text-decoration: none;
    text-transform: uppercase;
  }

  &__tiles {
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;

    & > * {
      flex: 1 0 87.5%;
      @include respond-above(md) {
        max-width: 540px;
        flex: 1 0 36%;
      }
    }
  }
}
</style>
